import { Injectable, signal } from '@angular/core';

import { billingTierLabel, resolveBillingTier } from '../utils/plan-tier.util';

export type PaymentSuccessPhase = 'idle' | 'activating';

export interface PaymentCelebration {
  roleName: string;
  planLabel: string;
  message: string;
}

const ACTIVATING_MESSAGE = 'Activating your new plan…';

@Injectable({ providedIn: 'root' })
export class PaymentSuccessService {
  readonly phase = signal<PaymentSuccessPhase>('idle');
  readonly overlayMessage = signal('');
  readonly celebration = signal<PaymentCelebration | null>(null);

  beginActivation(): void {
    this.phase.set('activating');
    this.overlayMessage.set(ACTIVATING_MESSAGE);
    this.celebration.set(null);
  }

  celebrate(assignedRole: string): void {
    const planLabel = billingTierLabel(resolveBillingTier([assignedRole]));
    this.celebration.set({
      roleName: assignedRole.toUpperCase(),
      planLabel,
      message: `Congratulations! You upgraded to the ${planLabel} plan.`,
    });
  }

  dismissOverlay(): void {
    this.phase.set('idle');
    this.overlayMessage.set('');
  }

  reset(): void {
    this.phase.set('idle');
    this.overlayMessage.set('');
    this.celebration.set(null);
  }
}
